import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';

//Pages
import Home from './pages/Home/Home';
import Ideen from './pages/Ideen/Ideen';
import AddIdee from './pages/Ideen/AddIdee';
import EditIdee from './pages/Ideen/EditIdee';

import LoginPage from './pages/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
<BrowserRouter >
      <Navbar />
      <Routes>
        <Route path='/' element={<Home />} />
<Route path="/login" element={<LoginPage />} />
        <Route path='/ideen' element={<ProtectedRoute><Ideen /></ProtectedRoute>} />
        <Route path='/ideen/addIdee' element={<ProtectedRoute><AddIdee /></ProtectedRoute>} />
        <Route path='/ideen/editIdee/:id' element={<ProtectedRoute><EditIdee /></ProtectedRoute>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
